import { eUnChunkSparito, gestisciChunkSparito } from '@utils/staleChunkReload'

/**
 * Il buco che questo file chiude.
 *
 * Le rotte si caricano con `lazy={() => import(...)}`. Dopo un rilascio i file
 * della versione precedente non esistono piu' e il rewrite SPA risponde con
 * `index.html`: il browser si aspetta JavaScript e trova `<`. Quell'import
 * fallisce, ma **react-router si prende lui il rifiuto** e disegna
 * l'`errorElement`, quindi non arriva nessun `unhandledrejection` e
 * `installStaleChunkReload`, che ascolta su `window`, non vede niente.
 *
 * Visto su iPhone il 12/09 alle 14:33, due minuti dopo un rilascio: l'utente
 * resta sulla schermata "Abbiamo riscontrato un problema" e l'unico bottone
 * era "Torna Indietro", che su questo errore non ripara niente.
 *
 * La cura sta qui e non nei 66 `lazy` del router: l'errore arriva comunque in
 * un solo posto. Contatore e finestra restano quelli di `gestisciChunkSparito`,
 * quindi un deploy davvero rotto non diventa un ciclo di ricariche.
 */

/** L'errore di rotta puo' essere un Error, una stringa o un oggetto di react-router. */
export const messaggioDi = (errore) => {
  if (!errore) return ''
  if (typeof errore === 'string') return errore
  return errore.message || ''
}

/** Safari mette il file in `fileName`, gli altri in `filename`: serve a capire se l'HTML arrivava da un .js. */
export const origineDi = (errore) => {
  if (!errore || typeof errore === 'string') return undefined
  return errore.fileName || errore.filename || undefined
}

export const eDaChunkSparito = (errore) =>
  eUnChunkSparito(messaggioDi(errore), origineDi(errore))

/** Ricarica su richiesta dell'utente (il bottone). Isolata qui per poterla sostituire nei test. */
export const ricaricaOra = () => {
  if (typeof window !== 'undefined' && window.location) window.location.reload()
}

/**
 * @returns {boolean} true se ha avviato la ricarica; false se l'errore non
 * c'entra, se i tentativi sono esauriti o se non c'e' una sessionStorage.
 */
export const ricaricaSeChunkSparito = (errore, opzioni = {}) => {
  if (!eDaChunkSparito(errore)) return false

  const finestra = typeof window !== 'undefined' ? window : undefined
  /* `in` e non `??`: uno storage passato apposta a null deve valere null,
     altrimenti il caso "non c'e' storage" non si puo' nemmeno provare. */
  const storage = 'storage' in opzioni ? opzioni.storage : finestra && finestra.sessionStorage
  if (!storage) return false

  /* La traccia (STU-424) dice che la ricarica e' partita da qui, dalla pagina
     d'errore di una rotta, e su quale percorso: la manda la pagina che nasce. */
  return gestisciChunkSparito({
    messaggio: messaggioDi(errore),
    origine: origineDi(errore),
    storage,
    reload: opzioni.reload ?? ricaricaOra,
    adesso: (opzioni.adesso ?? Date.now)(),
    sorgente: 'route_error',
    pagina: finestra && finestra.location ? finestra.location.pathname : undefined,
  })
}
